<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <router-view />
      <div class="loadingBox" v-if="loading">
        <a-spin class="loading" />
      </div>
    </div>
  </a-config-provider>
</template>

<script>
// import Menu from './components/menu'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  components:{
    // Menu
  },
  name: 'App',
  data(){
    return {
      zh_CN
    }
  },
  computed: {
    loading () {
      return this.$store.getters.getLoading
    }
  },
  mounted(){
    // console.log(this.loading)
  }
}
</script>

<style lang="scss">
body,html{
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* margin-top: 60px; */
}
.loadingBox{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(255,255,255,0.5);
  z-index: 99999999;
}
.loading{
  position: fixed !important;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
.container-block{
  border-radius: 5px;
  background: #fff;
  padding:15px;
  &.header{
    margin-bottom:20px;
  }
  &.table{
    padding-bottom: 0;
  }
}

</style>
